var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95397 11.1864L0.25 14L2.66534 4.18932L5.67844 7.0819L10.5388 2.01904C10.7038 1.84716 10.9317 1.75 11.17 1.75C11.4083 1.75 11.6362 1.84716 11.8012 2.01904L15.37 5.73652L20.6188 0.269035C20.9535 -0.0795746 21.5074 -0.0908794 21.856 0.243787C22.2046 0.578451 22.2159 1.13236 21.8812 1.48096L16.0012 7.60597C15.8362 7.77784 15.6083 7.875 15.37 7.875C15.1317 7.875 14.9038 7.77784 14.7388 7.60597L11.17 3.88848L6.94087 8.29383L9.95397 11.1864Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/Decrease.7a6f7bd7c8080fe262c904bd40d2f895.svg";
export { ForwardRef as ReactComponent };